import React, { useEffect, useState } from 'react';

import { setCartCookie, isCartSynced, setIsCartSynced, getCartCookie } from '../utils/cart';

import Box from '../../../components/Box/Box';
import Icon from '../../../components/Icon/Icon';
import { Link } from '../../../components/Link';
import BadgeCounter from './BadgeCounter';
import fetchApI from '../utils/fetchApi';

type TCart = {
  cart: {
    url: string;
    role: string;
    text: string;
    badge: {
      endpoint: string;
      name: string;
    };
  };
};

const Cart = ({ cart }: TCart) => {
  const { url, role, text, badge } = cart;

  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!isCartSynced()) {
      const syncCart = async () => {
        try {
          // @TODO Refactor: consider a separate function
          const { numberOfItems } = (await fetchApI(badge.endpoint)) as Awaited<Promise<{ numberOfItems: number }>>;
          setCount(numberOfItems);
          setCartCookie({ numberOfItems });
          setIsCartSynced();
        } catch {}
      };

      syncCart();
    } else {
      setCount(getCartCookie().numberOfItems);
    }
  }, [badge.endpoint]);

  if (!count) {
    return null;
  }

  return (
    <li className="hz-hide-lte-md">
      <Link href={url} role="button" data-role={role} title={text} tabIndex={0}>
        <Box as="div" parent="Button" name="badge">
          <Icon name="shoppingcart" color={'text-controls-default'} />
          <BadgeCounter badgeName={badge.name} badgeCount={count} />
        </Box>
      </Link>
    </li>
  );
};

export default Cart;
